import { useQuery } from "@tanstack/react-query";
import { fetchMarketplaceActivity } from "PFCore/services/marketplace/fetch_marketplace_activity";
import { MatchedActivity } from "PFTypes";
import { Id } from "PFTypes/id";
import { QueryOptions } from "PFTypes/request_options";

import { activitiesKeys } from "../query_keys";

export const useMarketplaceActivity = (
  activityId: Id,
  options: QueryOptions<MatchedActivity["activity"]> = {}
) =>
  useQuery<MatchedActivity["activity"], unknown, MatchedActivity["activity"]>(
    activitiesKeys.marketplaceActivity(activityId),
    () => fetchMarketplaceActivity(activityId),
    options
  );
